import { Button, Icon, Popover } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

const EditBtn = ({ isEditMode, onEdit }) => {
  if (isEditMode) {
    return null;
  }

  return (
    <Popover
      text="Edit team name"
      width="fit-content"
      tabIndex="-1"
      direction="top"
      mt="1px"
    >
      <Button
        dataTestId="edit-btn"
        iconOnly
        onClick={onEdit}
        height="22px"
        width="22px"
        borderRadius="22px"
        variant="borderGrey"
        bg="white"
        ariaLabel="Edit team name"
      >
        <Icon icon={["fas", "pencil"]} color="greyDarkest" />
      </Button>
    </Popover>
  );
};

EditBtn.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default React.memo(EditBtn);
